(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
/* Odtwarzacz: iframe powstaje DOPIERO po kliknieciu i tylko z domeny
       youtube-nocookie.com, bez autoplay przy pierwszym zaladowaniu strony.
       Bez tego skryptu wszystkie kafle sa zwyklymi odnosnikami do YouTube. */
    (function () {
        var ramka = document.getElementById('yt-ramka');
        var kafle = document.getElementById('yt-kafle');
        var tytul = document.getElementById('yt-tytul');
        var link  = document.getElementById('yt-link');
        var najnowsze = document.getElementById('yt-najnowsze');
        var data  = document.getElementById('yt-data');
        if (!ramka) return;

        function wstaw(id, nazwa, kiedy) {
            if (!/^[0-9A-Za-z_-]{11}$/.test(id)) return false;
            var ifr = document.createElement('iframe');
            ifr.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0';
            ifr.title = ramka.dataset.tytul + (nazwa ? ' — ' + nazwa : '');
            ifr.loading = 'lazy';
            ifr.referrerPolicy = 'strict-origin-when-cross-origin';
            ifr.allow = __pewniaki_inline_cfg[0];
            ifr.setAttribute('allowfullscreen', '');
            ramka.innerHTML = '';
            ramka.appendChild(ifr);
            if (link) link.href = 'https://www.youtube.com/watch?v=' + id;
            if (tytul && nazwa) tytul.textContent = nazwa;
            if (data && kiedy) data.textContent = kiedy;
            /* Plakietka „Najnowsze" mowi prawde tylko o pierwszym nagraniu. */
            if (najnowsze) najnowsze.hidden = (id !== ramka.dataset.pierwszy);
            return true;
        }

        var start = document.getElementById('yt-start');
        if (start) {
            start.addEventListener('click', function (e) {
                if (wstaw(start.dataset.film, tytul ? tytul.textContent : '', data ? data.textContent : '')) e.preventDefault();
            });
        }

        if (kafle) {
            kafle.addEventListener('click', function (e) {
                var kafel = e.target.closest('[data-film]');
                if (!kafel) return;
                if (wstaw(kafel.dataset.film, kafel.dataset.tytul || '', kafel.dataset.data || '')) {
                    e.preventDefault();
                    ramka.scrollIntoView({ block: 'center' });
                }
            });
        }
    })();
})();
